<template>
  <div class="multi-holder">
    <ValidationProvider
      :bail="bail"
      :name="$attrs.name"
      :rules="rules"
      :vid="vid"
      mode="eager"
      v-slot="{ valid, errors }"
    >
      <b-form-group v-bind="$attrs">
        <MultiSelect
          class="multi-style"
          v-model="innerValue"
          :id="name"
          :label="name"
          :track-by="trackBy"
          :placeholder="placeholder"
          open-direction="bottom"
          :options="options"
          :multiple="true"
          :searchable="true"
          :loading="isLoading"
          :internal-search="false"
          :clear-on-select="false"
          :closeOnSelect="false"
          :options-limit="5"
          :limit="3"
          autocomplete="off"
          :limit-text="limitText"
          :max-height="600"
          :show-no-results="false"
          :hide-selected="true"
          :disable="disabled"
          selectLabel=""
          :taggable="false"
          @search-change="onsearch"
          :preserveSearch="true"
          tagPosition="bottom"
          v-bind="$attrs"
          :state="errors[0] ? false : (valid ? true : null)"
        >
          <!-- <template slot="tag" slot-scope="{ option, remove }">
            <slot name="tag" v-bind:tag="{option,remove}"></slot>
          </template> -->
          <!-- <template slot="clear" slot-scope="props">
            <div
              class="multiselect__clear"
              v-if="selectedItems.length"
              @mousedown.prevent.stop="clearAll(props.search)"
            ></div>
          </template> -->
          <template slot="option" slot-scope="props">
            <slot name="options" v-bind:options="props"></slot>
            <!-- <img class="option__image" :src="props.option.img" alt="No Man’s Sky" />
            <div class="option__desc">
              <span class="option__title">{{ props.option.title }}</span>
              <span class="option__small">{{ props.option.desc }}</span>
            </div> -->
          </template>
          <template slot="beforeList">
            <slot name="beforeList"></slot>
          </template>
          <span slot="noResult">Oops! No elements found. Consider changing the search query.</span>
        </MultiSelect>
        <b-form-invalid-feedback id="inputLiveFeedback">{{ errors[0] }}</b-form-invalid-feedback>
      </b-form-group>
    </ValidationProvider>
  </div>
</template>

<script>
import MultiSelect from "vue-multiselect";
import { ValidationProvider } from "vee-validate";
import "vue-multiselect/dist/vue-multiselect.min.css";

export default {
  components: {
    ValidationProvider,
    MultiSelect
  },
  props: {
    vid: {
      type: String
    },
    rules: {
      type: [Object, String],
      default: ""
    },
    // must be included in props
    value: {
      type: null
    },
    bail: { type: Boolean, default: true },
    placeholder: String,
    disabled: { type: Boolean, default: false },
    type: {
      type: String,
      default: "text"
    },
    name: String,
    trackBy: String,
    options: Array,
    isLoading: {
      type: Boolean,
      default: false
    },
    onsearch: {
      type: Function,
      default: () => {}
    },
    selectedItems: Array
  },
  data: () => ({
    innerValue: ""
  }),
  methods: {
    limitText(count) {
      return `and ${count} other countries`;
    }
  },
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit("input", newVal);
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal;
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
    
  },
  mounted(){
    //this.$refs.multiselectRef.$refs.search.setAttribute("autocomplete", "off")
  }
};
</script>

<style >
/* .multi-holder >>> .multiselect{
  background-color: transparent;
    border: 1px solid #E3E3E3;
    border-radius: 5px;
    color: #2c2c2c;
    line-height: normal;
    font-size: 0.8571em;
    min-height: 100%;
    -webkit-transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;
    transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;
    -webkit-box-shadow: none;
    box-shadow: none;
}

input#select-item {
    border: none;
    height: 30px;
}

.multiselect--active input#select-item{
  border: 1px solid red;
} */

.multi-style {
  font-size: 12px;
  border: none;
  border-radius: 5px;
}

.multiselect__tags {
  min-height: 40px;
  display: flex;
  align-items: center;
  padding: 0 40px 0 15px;
  border-radius: 5px;
  border: 1px solid #e8e8e8;
  background: #fff;
  font-size: 14px;
}
.multiselect__input,
.multiselect__single {
  position: relative;
  display: inline-block;
  min-height: 20px;
  line-height: 20px;
  border: none;
  border-radius: 5px;
  background: #fff;
  padding: 0 0 0 5px;
  width: 100%;
  -webkit-transition: border 0.1s ease;
  transition: border 0.1s ease;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin-bottom: 0px;
  vertical-align: middle;
  font-size: 12px;
}
.multiselect__placeholder {
  color: #adadad;
  display: inline-block;
  font-size: 12px;
  margin-bottom: 0px;
  /* padding-top: 2px; */
}
.multi-style {
  border: none;
}
.multiselect__tags-wrap {
    display: none;
}
</style>
